<form [formGroup]="form_Group" (ngSubmit)="save()">
  <div class="modal-header">
    <h4 [qcId]="'btn-title'" class="modal-title black" *ngIf="!reason?.id">إضافة سبب جديد</h4>
    <h4 [qcId]="'btn-title'" class="modal-title black" *ngIf="reason?.id">تعديل السبب</h4>
    <button [qcId]="'btn-close'" type="button" class="close mt-1" aria-label="Close" (click)="activeModal.dismiss()">
      <span aria-hidden="true" style="font-size: 50px">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="row">
      <div class="col-sm-12 col-12">
        <div class="form-group">
          <label [qcId]="'lbl-desc'" for="text" class="mb-3">
            {{ "Reasons.reasonText" | translate }}
            <span class="text-danger"> *</span>
          </label>
          <input [qcId]="'reason-description'" type="text" class="form-control" formControlName="description"
            placeholder="{{ 'Reasons.reasonText_p' | translate }}" />

          <div [qcId]="'div-error1'" class="text-danger mt-2">
            <div *ngIf="controlHasError('required', 'description', form_Group)">
              {{ "Reasons.reasonText_Required" | translate }}
            </div>
            <div
              *ngIf="controlHasError('minlength', 'description', form_Group) || controlHasError('maxlength', 'description', form_Group)">
              {{"Reasons.Description_Length" | translate}}
            </div>
            <div *ngIf="controlHasError('pattern', 'description', form_Group)">
              {{"Reasons.Description_Pattern" |translate}}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button [qcId]="'btn-back'" type="button" class="btn btn-outline-secondary" (click)="activeModal.dismiss()">
      رجوع
    </button>
    <button [qcId]="'btn-submit'" type="submit" class="btn btn-green pl-5 pr-5">
      {{ !reason?.id ? "إضافة" : "تعديل" }}
    </button>
  </div>
</form>